/// <amd-module name="Environments/Client/Constants" />

export class ServiceInstanceIds
{
    public static Tfs: string = "00025394-6065-48ca-87d9-7f5672854ef7";
}

export class DataProviderIds {
    public static EnvironmentDataProvider: string = "ms.vss-environments-web.environment-details-data-provider";
    public static EnvironmentRunJobsDataProvider: string = "ms.vss-environments-web.environment-rundetails-jobs-data-provider";
    public static EnvironmentRunCommitsDataProvider: string = "ms.vss-environments-web.environment-rundetails-commits-data-provider";
    public static EnvironmentRunWorkitemsDataProvider: string = "ms.vss-environments-web.environment-rundetails-workitems-data-provider";
    public static EnvironmentDeploymentHistoryDataProvider: string = "ms.vss-environments-web.environment-deployment-history-data-provider";
    public static LinkedPipelineDefinitionsDataProvider: string = "ms.vss-environments-web.environment-linked-pipelines-provider";
    public static EnvironmentResourcesTagUpdateDataProvider: string = "ms.vss-environments-web.environment-resources-tag-update-data-provider";
    public static EnvironmentDeleteResourceDataProvider: string = "ms.vss-environments-web.environment-delete-resource-data-provider";
}

export class TabContributionIds {
    public static EnvironmentJobDetailsTab = "ms.vss-environments-web.environment-rundetails-jobshistory-tab"
}